<template>
  <div id="scoreScheduleEachLessonPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="جدول زمانی نمره برای هر درس"></ActionBar>
    <div class="container mx-auto no-gutters p-0 mt-2">
      <div class="row">
        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">از تاریخ:</span></div>
          <div>
            <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-left="100"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate1"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    class="input-border"
                    color="forth"
                    dense
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date1"
                  color="forth"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker1"></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تا تاریخ:</span></div>
          <div>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate2"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    class="input-border"
                    dense
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date2"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker2"></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3 align-self-end">
          <v-btn rounded block class="mt-8 mt-md-0 mt-lg-8" color="primary" @click="searchResult">
            جستجو
          </v-btn>
        </div>
      </div>
    </div>
    <div class="row container mx-auto no-gutters p-0 mt-10">
      <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
        در حال جستجو
        <v-progress-linear
            color="deep-purple accent-4"
            height="6"
            indeterminate
            rounded
        ></v-progress-linear>
      </div>
      <div v-else-if="isLoaded" class="col-12 col-sm-10 col-md-6 mx-auto border">
        <div v-if="!hasReport" class="mx-2 mt-5 knowledge-base-body">
          <div class="col-12">
            <v-alert
                border="bottom"
                class="text-center"
                color="forth"
                dark>
           گزارشی برای تاریخ انتخاب شده وجود ندارد.
            </v-alert>
          </div>
        </div>
        <v-simple-table
            v-else
            fixed-header>
          <thead>
          <tr>
            <th class="border-left">
              عنوان
            </th>
            <th class="border-left">
              مجموع ساعت
            </th>
            <th class="border-left">
              میانگین نمره (%)
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in tableItems"
              :key="item.LeasonFunID">
            <td class="border-left">{{ item.LeasonName }}</td>
            <td class="border-left">{{ (item.hours) }}</td>
            <td class="border-left">{{ item.Avregae.toFixed(0) }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
    <FooterMenu/>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import moment from "moment-jalaali";

export default {
  name: "ScoreScheduleEachLesson",
  metaInfo: {
    title: 'مسیربرتر-جدول زمانی نمره برای هر درس'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    inputDate1: '',
    inputDate2: '',
    menu1: false,
    date1: '',
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu2: false,
    tableItems: [],
    dataLoading: false,
    isLoaded: false,
    hasReport: false,
  }),
  mounted() {
    this.inputDate2 = this.$convertDate(this.date2)

    let current = new Date()
    current.setDate(current.getDate() - 365)
    this.date1 = current.toISOString().substr(0, 10)
    this.inputDate1 = this.$convertDate(this.date1)
    _this = this
  },
  methods: {
    inputDatePicker1() {
      this.menu1 = false

      this.inputDate1 = moment(this.date1).format('jYYYY/jMM/jDD')
    },
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    searchResult() {
      this.dataLoading = true
      _this.tableItems = []
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", (this.inputDate1));
      urlencoded.append("EndDate", (this.inputDate2));
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_ScoreScheduleEachLesson", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.dataLoading = false
            let json = JSON.parse(result)
            if (json.length > 0) {
              for (let i = 0; i < json.length; i++) {
                let tmp = parseInt(json[i].Minutes / 60);
                let tmp2 = (json[i].Minutes) % 60;
                json[i].hours = tmp + ":" +tmp2;
              }
              _this.hasReport = true
              _this.tableItems = json
              _this.isLoaded = true
            } else {
              _this.hasReport = false
              _this.isLoaded = true
            }
            // console.log(json)

          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>